import { DialogButton } from './Dialog';
/** @component React Components */
export const Button = DialogButton?.render({}).type;
